import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import user from './modules/user'
import dictOptions from './modules/dictOptions'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    dictOptions
  },
  getters
})

export default store
